import React, { useEffect, useState } from "react";
import { MessageType, Product } from "../constants";
import "../modal.css";
import HealthMultiplePlanSelection from "./Health/MultiplePlanSelection";
import TravelMultiplePlanSelection from "./Travel/MultiplePlanSelection";

export default function MultiplePlanSelection({ message, sendMessage, userId, GAEvent, productId }) {
  const [openModal, setOpenModal] = useState("")
  const [selectedPlans, setSelectedPlans] = useState([])
  const [selectedPlanIds, setSelectedPlanIds] = useState([])
  const [planList, setPlanList] = useState([])
  const [insurerList, setInsurerList] = useState({})
  const [content, setMessageContent] = useState("")
  const [selectedInsurer, setSelectedInsurer] = useState("")
  // const content = JSON.parse(message.content)
  const inputStatus = (planId) => {
    if (!selectedPlanIds.includes(planId) && selectedPlanIds.length >= 2) {
      return "disable"
    }
    return ""
  }
  useEffect(() => {
    let insurers = {}
    for (let plan of planList) {
      insurers[plan.supplier_id] = {
        "supplier_id": plan.supplier_id,
        "supplier_name": plan.supplier_name,
        "ImageUrl": plan.ImageUrl
      }
    }
    console.log(insurers)
    setInsurerList(insurers)
  }, [planList])

  useEffect(() => {
    console.log(message)
    if (message && message.type.toLowerCase() === MessageType.json && message.content) {
      let content = JSON.parse(message.content)
      setMessageContent(content)
      setPlanList(content.choices)
      GAEvent({ eventAction: "compare-plans-list", eventLabel: "visible" })
    }
  }, [message])
  useEffect(() => {
    // let content = JSON.parse(message.content)
    if (content.selected && message.from === userId) {
      setOpenModal("")
    }
    else {
      setOpenModal("open")
    }
  }, [message])
  const SelectPlan = (plan, checked) => {
    setSelectedInsurer('')
    let planIds = [...selectedPlanIds]
    let plans = [...selectedPlans]
    if (checked && selectedPlans.length < 2) {
      planIds.push(plan.plan_id)
      setSelectedPlanIds(planIds)
      plans.push(plan)
      setSelectedPlans(plans)
      GAEvent({ eventAction: "compare-plan-list-selected", eventLabel: plan.plan_name })
    }
    else if (!checked) {
      const index = planIds.indexOf(plan.plan_id)
      if (index > -1) {
        planIds.splice(index, 1)
      }
      setSelectedPlanIds(planIds)

      const planindex = plans.indexOf(plan)
      if (index > -1) {
        plans.splice(planindex, 1)
      }
      setSelectedPlans(plans)
      GAEvent({ eventAction: "compare-plan-list-rejected", eventLabel: plan.plan_name })
    }
    if (message && message.type.toLowerCase() === MessageType.json && message.content) {
      let content = JSON.parse(message.content)
      setMessageContent(content)
      setPlanList(content.choices)
    }
  }
  const handleSearch = (planName) => {
    if (content && content.choices) {
      let list = content.choices.filter((obj) =>
        obj.plan_name &&
          (obj.plan_name.toLowerCase().includes(planName.toLowerCase().trim()) || obj.supplier_name.toLowerCase().includes(planName.toLowerCase().trim()))
          ? true
          : false
      );
      setPlanList(list)
    }
  }
  // handleSubmit
  const SearchPlan = (planName) => {
    if (content && content.choices) {
      let list = content.choices.filter((obj) =>
        obj.plan_name &&
          (obj.plan_name.toLowerCase().includes(planName.toLowerCase().trim()))
          ? true
          : false
      );
      setPlanList(list)
    }
  }
  const SearchInsurer = (insurerName) => {
    if (content && content.choices) {
      let list = content.choices.filter((obj) =>
        obj.plan_name &&
          (obj.supplier_name.toLowerCase().includes(insurerName.toLowerCase().trim()))
          ? true
          : false
      );
      setPlanList(list)
    }
  }
  const handleSubmit = () => {
    if (selectedPlans.length === 2) {
      let resp = { "plan": selectedPlans, "type": content.type }
      let json = {
        content: JSON.stringify(resp),
        refMessageId: message.messageId,
        type: MessageType.json,
      };
      sendMessage(json);
    }
    else {
      setSelectedInsurer('')
    }
  }
  const removePlan = (plan) => {
    let planIds = [...selectedPlanIds]
    let plans = [...selectedPlans]
    const index = planIds.indexOf(plan.plan_id)
    if (index > -1) {
      planIds.splice(index, 1)
    }
    setSelectedPlanIds(planIds)

    const planindex = plans.indexOf(plan)
    if (index > -1) {
      plans.splice(planindex, 1)
    }
    setSelectedPlans(plans)
    GAEvent({ eventAction: "compare-plan-list-rejected", eventLabel: plan.plan_name })
  }
  return (
    <>
      {productId === Product.Health ?
        <HealthMultiplePlanSelection
          insurerList={insurerList}
          openModal={openModal}
          handleSearch={handleSearch}
          planList={planList}
          inputStatus={inputStatus}
          selectedPlanIds={selectedPlanIds}
          SelectPlan={SelectPlan}
          handleSubmit={handleSubmit}
          selectedInsurer={selectedInsurer}
          setSelectedInsurer={setSelectedInsurer}
          selectedPlans={selectedPlans}
          removePlan={removePlan}
          SearchPlan={SearchPlan}
          SearchInsurer={SearchInsurer}
        />
        : null}
      {productId === Product.Travel ?
        <TravelMultiplePlanSelection
          openModal={openModal}
          handleSearch={handleSearch}
          planList={planList}
          inputStatus={inputStatus}
          selectedPlanIds={selectedPlanIds}
          SelectPlan={SelectPlan}
          handleSubmit={handleSubmit}
        />
        : null}
    </>
  );
}
